import React from 'react'
import Barcode from 'react-barcode'
import Text from '../../Text'
import * as S from './style'

function BatchMovementTag({ obj, isProductNotFound = false }) {
  const styleTagWhite = {
    backgroundColor: '#fff',
    color: '#000',
    width: '100%'
  }
  const styleTagBlack = {
    backgroundColor: '#000',
    color: '#fff',
    width: '100%',
    fontSize: '30px'
  }

  const StorageReceivement = {
    PALLET: 'PALLET',
    CAGE: 'GAIOLA',
  }

  const colorStorageReceivement = obj.suggestedStorageReceivement === StorageReceivement.PALLET ? '#000' : '#fff'

  const styleProductNotFound = isProductNotFound ? styleTagBlack : styleTagWhite
  return (
    <S.TagContainer>
      {obj.suggestedStorageReceivement && (
        <S.ContainerStorage isPallet={obj.suggestedStorageReceivement === StorageReceivement.PALLET}>
          <Text
            textType="label"
            plainText={obj.suggestedStorageReceivement}
            style={{
              textAlign: 'center',
              fontSize: '15px',
              fontWeight: 'bold',
              color: colorStorageReceivement,
            }}
          />
          <Text
            textType="label"
            plainText={obj.suggestedStorageReceivement}
            style={{
              textAlign: 'center',
              fontSize: '15px',
              fontWeight: 'bold',
              color: colorStorageReceivement,
            }}
          />
          <Text
            textType="label"
            plainText={obj.suggestedStorageReceivement}
            style={{
              textAlign: 'center',
              fontSize: '15px',
              fontWeight: 'bold',
              color: colorStorageReceivement,
            }}
          />
        </S.ContainerStorage>
      )}
      <S.ContentHeader styleProductIsNotFount={styleProductNotFound}>
        <S.ContainerModelDescription>
        {obj.productCode && (
          <Text
            textType="label"
            plainText={`MODELO: ${obj.productCode}`}
            style={{
              textAlign: 'center',
              fontSize: '11px',
            }}
          />
        )}
        <Text
          textType="header"
          plainText={obj.productDescription}
          style={{ textAlign: 'center', fontSize: '17px', ...styleProductNotFound }}
        />
        </S.ContainerModelDescription>
        <S.ContainerNumber>
          <Text
            textType="header"
            plainText={String(obj.batchNumber).padStart(3, '0')}
            style={{
              textAlign: 'center',
              color: '#fff',
              fontWeight: 'bold',
            }}
          />
        </S.ContainerNumber>
      </S.ContentHeader>
      <S.ContentBarcode>
        <S.TagText
          textType="label"
          style={{ fontWeight: 'bold', fontSize: '16px' }}
        >
          {obj.addressTag ? obj.addressTag : "Rua não localizada"} - {obj.fc}
        </S.TagText>
        <S.TagText
          textType="label"
          style={{ fontWeight: 'bold', fontSize: '14px' }}
        >
          LOTE
        </S.TagText>
        <Barcode
          value={String(obj.lotId)}
          fontSize={13}
          format="CODE39"
          width={1.5}
          height={40}
          marginTop={3}
          marginBottom={6}
        />
      </S.ContentBarcode>
      <S.ContentBatch>
        <S.WrapperContentBatchInfo>
          <S.ContentBatchInfo>
            <S.TagText>
              VALIDADE:{' '}
              <b data-testid="bmt-expiration-date">{obj.expirationDate}</b>
            </S.TagText>
          </S.ContentBatchInfo>
          <S.ContentBatchInfo>
            <S.TagText>
              QTD. ÚTIL:{' '}
              <b data-testid="bmt-received-qty">
                {obj.qty}
                {obj.measureUnity}
              </b>
            </S.TagText>
            <S.TagText>
              QTD. AVARIADA:{' '}
              <b data-testid="bmt-received-qty">
                {obj.damageQuantity}
                {obj.measureUnity}
              </b>
            </S.TagText>
          </S.ContentBatchInfo>
        </S.WrapperContentBatchInfo>
        <S.WrapperContentBatchInfo>
          <S.ContentBatchInfo>
            <S.TagText>
              DATA RECEB.:{' '}
              <b data-testid="bmt-received-date">{obj.receivementDate}</b>
            </S.TagText>
            <S.TagText>
              HORA RECEB.:{' '}
              <b data-testid="bmt-received-hour">{obj.receivementHour}</b>
            </S.TagText>
          </S.ContentBatchInfo>
          <S.OperatorContentInfo>
            <S.TagOperatorNameText>
              RECEB. POR:{' '}
              <b data-testid="bmt-received-by">{obj.operatorName}</b>
            </S.TagOperatorNameText>
          </S.OperatorContentInfo>
        </S.WrapperContentBatchInfo>
      </S.ContentBatch>
    </S.TagContainer>
  )
}

export default BatchMovementTag
